import {useEffect, useRef} from "react";
import {useSelector, useDispatch} from 'react-redux';
import {checkAuthorizationStatus, setOpLoading, setShowQrWaitingImage} from '../features/authorizationSlice';
import {ACTION_TYPES} from "./actionTypes";
import {
    setLoading,
    setResponseTitle,
    setResponseInfo
} from "../features/responseSlice";
import {qrTimeoutMinutes} from "../utils/Constants";
import {setQrTimeout} from '../features/authorizationSlice';

import useResponse from "./responseHandler";
import useOrderProcessingApi from "../api/OrderProcessingApi";
import useEmployeesApi from "../api/EmployeesApi";
import useDropOffApi from "../api/DropOffApi";
import { setBlockedEmployeeStatus, setEmployeeActiveButton } from "../features/employeeSlice";
import { setTodoActiveButton } from "../features/TodoSlice";
import { useNavigate } from "react-router-dom";
// import { BaseRequest } from '../utils/Classes/Requests/BaseRequest';


export default function useCheckAuthorizationStatusHandler(onCloseQrReset) {
    const { CancelOrder, DeleteOrder } = useOrderProcessingApi();
    const { AddEmployee, EditEmployee, ChangeStatusEmployee, DeleteEmployee, GetEmployees } = useEmployeesApi();
    const { ScanQR } = useDropOffApi();

    const navigate = useNavigate();

    const controller = new AbortController();
    const timer = useRef(0);
    const {
        authorizationCode,
        status,
        qrTimeout,
        error,
        actionType,
        actionPayload
    } = useSelector((state) => state.authorization);

    const dispatch = useDispatch();
    const _isMounted = useRef(false);

    useEffect(() => {
        if (!_isMounted.current) {
            _isMounted.current = true;
            return;
        }
        let countDownDate = new Date();
        countDownDate.setMinutes(countDownDate.getMinutes() + qrTimeoutMinutes);
        countDownDate = countDownDate.getTime();

        if (!qrTimeout && authorizationCode && authorizationCode.length > 0) {
            timer.current = setInterval(() => {
                let now = new Date().getTime();
                let distance = countDownDate - now;

                if (distance < 0 || (!authorizationCode && authorizationCode.length === 0)) {
                    clearInterval(timer.current);
                    dispatch(setQrTimeout(true));
                    return;
                }
                dispatch(checkAuthorizationStatus({authCode: authorizationCode, controller}))
            }, 2000);
        } else {
            controller.abort();
            clearInterval(timer.current);
        }
    }, [authorizationCode]);

    const {successResponse, errorResponse} = useResponse();

    useEffect(() => {
        const check = async (actionType, payload) => {
            let data;
            switch (actionType) {
                case ACTION_TYPES.CANCEL_ORDER:
                    dispatch(setLoading("pending"));
                    data = await CancelOrder(payload).then((res) => {
                        successResponse(res);
                    }).catch((error) => {
                        errorResponse(error);
                    });
                    break;
                case ACTION_TYPES.ADD_EMPLOYEE:
                    dispatch(setLoading("pending"));
                    data = await AddEmployee(payload).then((res) => {
                        successResponse(res);
                        dispatch(setEmployeeActiveButton({ name: "Employees"}));
                    }).catch((error) => {
                        errorResponse(error);
                    });
                    break;
                case ACTION_TYPES.EDIT_EMPLOYEE:
                    dispatch(setLoading("pending"));
                    await EditEmployee(payload)
                    .then((res) => {
                        successResponse(res);
                        GetEmployees();
                    })
                    .catch((error) => {
                        errorResponse(error);
                    });
                    break;
                    case ACTION_TYPES.BLOCK_EMPLOYEE:
                        dispatch(setLoading("pending"));
                        data = await ChangeStatusEmployee(payload)
                            .then((res) => {
                                successResponse(res);
                            })
                            .catch((error) => {
                                errorResponse(error);
                            })
                            .finally(() => {
                                GetEmployees();
                            });
                        break;                    
                case ACTION_TYPES.DELETE_EMPLOYEE:
                    dispatch(setLoading("pending"));
                    data = await DeleteEmployee(payload).then((res) => {
                        successResponse(res);
                        GetEmployees();
                    }).catch((error) => {
                        errorResponse(error);
                    });
                    break;
                case ACTION_TYPES.SCAN_QR:
                    dispatch(setLoading("pending"));
                    data = await ScanQR(payload).then((res) => {
                        successResponse(res);
                        navigate("/todo");
                        dispatch(setTodoActiveButton({ name: "OrderTable" }));   
                    }).catch((error) => {
                        errorResponse(error);
                        navigate("/todo");
                        dispatch(setTodoActiveButton({ name: "OrderTable" }));   
                    });
                    break;
                case ACTION_TYPES.DELETE_ORDER:
                    dispatch(setLoading("pending"));
                    data = await DeleteOrder(payload).then((res) => {
                        successResponse(res);
                    }).catch((error) => {
                        errorResponse(error);
                    });
                    break;
                default:
                    break;
            }

            return data;
        }

        if (error || qrTimeout || (status && status.length > 0 && (status === "AUTHORIZED" || status === "EXPIRED" || status === "CLOSED" || status === "USED"))) {
            if (status === "AUTHORIZED") {
                // const baseRequest = new BaseRequest(sessionStorage.getItem("SessionID"));
                const payload = {
                //   ...baseRequest,
                   ...actionPayload, authorizationCode: authorizationCode}
                check(actionType, payload);
                dispatch(setOpLoading("pending"));
            }
            onCloseQrReset();
            clearInterval(timer.current);
        }
    }, [status, actionType, actionPayload]);
}